<div fxLayout="column" fxLayoutGap="10px">
  <h2 class="page-header left">
    Mantenimiento de CAI
  </h2>
  <div fxLayout="row" fxLayout.lt-md="column" class="right">
    <div *ngIf="canCreateUpdate">
      <button mat-icon-button color="primary" class="button1" (click)="addRow()">
        <mat-icon>add_circle</mat-icon>
      </button>
      <button mat-icon-button color="primary" class="button1" (click)="saveRows()" [disabled]="disableSaveButton">
        <mat-icon>save</mat-icon>
      </button>
    </div>
<!--    <button mat-icon-button color="primary" (click)="refresh()">-->
<!--      <mat-icon>refresh</mat-icon>-->
<!--    </button>-->
  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div class="table-height">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
      <!-- nroCai Column -->
      <ng-container matColumnDef="nroCai">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Nro. CAI
          <rem-string-filter #tableFilter columnDef="nroCai" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <span *ngIf="!element.editing">{{ element.nroCai }}</span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-mtext">
            <input autocomplete="off" matInput [(ngModel)]="element.nroCai" required minlength="1" maxlength="14"
                   pattern="^\d+$">
            <mat-icon matPrefix *ngIf="isDirty(element, 'nroCai')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- fecha desde cai Column -->
      <ng-container matColumnDef="fecDesdeCai">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fecha<br>Desde CAI
          <rem-date-filter #tableFilter columnDef="fecDesdeCai" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.editing">{{ element.fecDesdeCai | customDate }}</span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-xltext">
            <input autocomplete="off" matInput [matDatepicker]="datepicker" [(ngModel)]="element.fecDesdeCai" required>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
            <mat-icon matPrefix *ngIf="isDirty(element, 'fecDesdeCai')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- fecha vto cai Column -->
      <ng-container matColumnDef="fecVtoCai">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fecha<br>Vto CAI
          <rem-date-filter #tableFilter columnDef="fecVtoCai" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.editing">{{ element.fecVtoCai | customDate }}</span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-xltext">
            <input autocomplete="off" matInput [matDatepicker]="datepicker" [(ngModel)]="element.fecVtoCai" required>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
            <mat-icon matPrefix *ngIf="isDirty(element, 'fecVtoCai')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- codTipoDocImp Column -->
      <ng-container matColumnDef="codTipoDocImp">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Tipo<br>Doc Code
          <rem-string-filter #tableFilter columnDef="codTipoDocImp" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.codTipoDocImp}}
        </td>
      </ng-container>
      <!-- Tipo Description Column -->
      <ng-container matColumnDef="tipoDesc">
        <th mat-header-cell *matHeaderCellDef scope="col"> Tipo<br>Documento
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          Remito
        </td>
      </ng-container>
      <!-- letra Column -->
      <ng-container matColumnDef="letra">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Letra
          <rem-string-filter #tableFilter columnDef="letra" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <span *ngIf="!(element.editing && element.add); else letraBox"> {{element.letra}} </span>
          <ng-template #letraBox>
            <mat-form-field appearance="fill" class="cell-width-smtext">
              <mat-select [(ngModel)]="element.letra" name="letra" required>
                <mat-option *ngFor="let letra of letraCodes" [value]=letra>
                  {{ letra }}
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirty(element, 'letra')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- ptoEmision Column -->
      <ng-container matColumnDef="ptoEmision">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> PTO Emision
          <rem-string-filter #tableFilter columnDef="ptoEmision" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <span *ngIf="!(element.editing && element.add); else ptoEmisionBox"> {{element.ptoEmision}} </span>
          <ng-template #ptoEmisionBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.ptoEmision" name="ptoEmision" required disableOptionCentering>
                <mat-option *ngFor="let ptoEmision of ptoEmisions" [value]="ptoEmision.code">{{ ptoEmision.code }}</mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirty(element, 'ptoEmision')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- estado Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col">Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.editing || element.add; else estadoBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #estadoBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" name="estado" required>
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirty(element, 'estado')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- usrCreacion Column -->
      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Usuario<br>Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrCreacion}}
        </td>
      </ng-container>
      <!-- fecCreacion Column -->
      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecCreacion | customDate}}
        </td>
      </ng-container>
      <!-- usrModif Column -->
      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Usuario<br>Modif
          <rem-string-filter #tableFilter columnDef="usrModif" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrModif ?? ""}}
        </td>
      </ng-container>
      <!-- fecModif Column -->
      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Modif
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecModif | customDate}}
        </td>
      </ng-container>
      <!-- Edited Indicator -->
      <ng-container matColumnDef="edited">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button *ngIf="element.editing && canCreateUpdate" (click)="revertRow(element)">
            <mat-icon color="tertiary">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="!element.editing && canCreateUpdate" (click)="edit(element)">
            <mat-icon color="secondary">create</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="defaultPageSize"
                 [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>
